import React, { Component } from "react";
import "./blankTemplate.scss";

export class BlankTemplate extends Component {
  render() {
    return (
      <div className="blankTemplate">
        <img id="logo" src="/images/logo.png" alt="SELPHO" />
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BlankTemplate/BlankTemplate.jsx